import { Trans } from 'react-i18next'
import styled from 'styled-components'
import { fontWeights, colors } from '@/styles'

const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`

const LeftColumnTop = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
`

const LeftColumnBottom = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`

const LeftColumnTitle = styled.span`
  font-weight: ${fontWeights.bold};
  text-align: left;
  font-size: 20px;
  line-height: 28px;
  margin: 32px 0 4px;
  color: ${colors.grey16};
`

const LeftColumnSubtitle = styled.span`
  margin: 0 0 16px;
`

const Bold = styled.span`
  font-weight: ${fontWeights.bold};
`

const LockedLeftColumn = ({ t, status, animatedScoreWrapper, viewSampleReportButton }) => {
  const content = {
    active: {
      title: t('l.application.view.locked_summary.title', 'Identify the right renters faster'),
      subtitle: (
        <Trans i18nKey="l.application.view.active_locked.text">
          Find the perfect tenants with the Trust Score - liv.rent's complete credit check & tenant
          screening tool.
        </Trans>
      )
    },
    no_credit_history: {
      title: t('l.application.view.no_credit_history.title', 'Limited information available'),
      subtitle: (
        <Trans i18nKey="l.application.view.no_credit_history_locked.text">
          This applicant <Bold>doesn’t yet have a credit history in Canada*</Bold> and as a result,
          their Trust Score is incomplete.
        </Trans>
      )
    },
    not_enough_info: {
      title: t('l.application.view.locked_summary.title', 'Identify the right renters faster'),
      subtitle: (
        <Trans i18nKey="l.application.view.active_locked.text">
          Find the perfect tenants with the Trust Score - liv.rent's complete credit check & tenant
          screening tool.
        </Trans>
      )
    },
    failed: {
      title: t('l.application.view.locked_summary.title', 'Identify the right renters faster'),
      subtitle: (
        <Trans i18nKey="l.application.view.active_locked.text">
          Find the perfect tenants with the Trust Score - liv.rent's complete credit check & tenant
          screening tool.
        </Trans>
      )
    }
  }

  if (!status) return

  return (
    <LeftColumn>
      <LeftColumnTop>{animatedScoreWrapper}</LeftColumnTop>
      <LeftColumnBottom>
        <LeftColumnTitle>{content[status]['title']}</LeftColumnTitle>
        <LeftColumnSubtitle>{content[status]['subtitle']}</LeftColumnSubtitle>
        {viewSampleReportButton}
      </LeftColumnBottom>
    </LeftColumn>
  )
}

export default LockedLeftColumn
